import { MeshSystem } from '../System/meshSystem';
import { Animation } from '../System/animation';
import { GravityGrid } from '../System/gravityGrid';
import { Star, StarInterface } from './star';
import { StarFighter } from './starFighter';
import { PlanetMap } from '../Map/planetMap';

export let BLACKHOLE_DEPTH = 50;
export let BLACKHOLE_SIZE = 10;

export class BlackHole extends StarFighter {

    gravityGrid: GravityGrid;
    introAnimation: Animation;
    depth = BLACKHOLE_DEPTH;
    blackHoleSize = 0;
    gravityField = BLACKHOLE_SIZE * 1.5;

    constructor(system: MeshSystem, gravityGrid: GravityGrid, planetMap: PlanetMap, playerInterface: StarInterface) {
        super(system, planetMap, playerInterface);
        this.gravityGrid = gravityGrid;
    }
    
    changeToBlackHole(c?: () => void) {
        this.setSize(30);
        this.build(c);
    }

    isBlackHole = false;
    
    build(c?: () => void) {
        this.isBlackHole = true;
        this.isStarVisible = false;
        this.introAnimation = new Animation(this.system.animationManager);
        const startSize = this.size;
        this.introAnimation.simple(200, (count, perc) => {
            this.setHeartScale((1 - perc) * startSize);
            this.blackHoleSize = 0.2 * BLACKHOLE_SIZE + perc * 0.8 * BLACKHOLE_SIZE;
            const depthPerc = Math.pow(perc, 2);
            this.depth =depthPerc * BLACKHOLE_DEPTH;
        }, () => {
            this.setSize(BLACKHOLE_SIZE)
            this.blackHoleSize = BLACKHOLE_SIZE;
            this._disposeStarFighter();
            c && c();
        });

        // setInterval(() => {
        //     this.setSize(BLACKHOLE_SIZE)
        //     console.log(this.gravityField);
            
        // }, 2000);
    }

    eatStar(star: Star) {
        let radius = 0;
        let velocity = 100;
        this.grabSatellite(star, radius, velocity);
        this.fixeSatellite(star);
    }

    dispose() {
        this.moveCatcher.stop();
        this.setMoving(false);
        this.transformMesh.dispose();
        this.gravityGrid.eraseMass(this.key);
    }
}